import React from 'react';
import {Tooltip} from "@chakra-ui/react";
import {LiaSlidersHSolid} from "react-icons/lia";
import {getLanguageDefaultConfig} from "../utils/utils.ts";
import _ from "lodash";
import {ILanguageConfiguration} from "../models/interfaces/languageConfiguration.interface.ts";
import useUserStore from "../store/useUserStore.ts";

interface LanguageDefaultConfigurationIconProps {
  lang: string;
  currentConfig: Partial<ILanguageConfiguration>;
  updateConfig: (config: Partial<ILanguageConfiguration>) => void;
}

const LanguageDefaultConfiguration: React.FC<LanguageDefaultConfigurationIconProps> = (
  {
    lang,
    currentConfig,
    updateConfig

  }: LanguageDefaultConfigurationIconProps) => {
  const {languageConfig} = useUserStore();

  const setDefaultConfig = () => {
    updateConfig(getLanguageDefaultConfig(languageConfig, lang))
  }

  const isDefaultConfig: boolean = _.isEqual(
    getLanguageDefaultConfig(languageConfig, lang),
    currentConfig
  );

  return (
    <Tooltip label="Use default configuration" hasArrow placement="top">
      <button
        type="button"
        aria-label="Use default configuration"
        disabled={isDefaultConfig}
        onClick={setDefaultConfig}
        className="inline-flex h-10 w-10 shrink-0 items-center justify-center text-white transition-colors hover:text-brandPurple-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brandPurple-300 disabled:pointer-events-none disabled:opacity-40"
      >
        <LiaSlidersHSolid size="25px" aria-hidden="true"/>
      </button>
    </Tooltip>
  )
}

export default LanguageDefaultConfiguration;
